require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./~/angular/index.js
// module id = 1
// module chunks = 0